import PlusIcon from "shared/components/icons/plus_icon"
import { verifyIntendedPromiseRejection } from "./utils/modal_promise"
import classNames from "classnames"

import styles from "./diy_add_tanda_button.module.scss"

interface Props {
  hasProBadge: boolean
  allowNewBadge: string
  anchorTitle: string
  onClick: () => void
}

export default function DIYAddTandaButton({ hasProBadge, allowNewBadge, anchorTitle, onClick }: Props) {
  return (
    <a
      className={classNames(styles.add, "plus-icon-button", { "button-with-badge-pro": hasProBadge })}
      onClick={verifyIntendedPromiseRejection(onClick)}
      title={anchorTitle}
      data-allow-new-badge={allowNewBadge}
    >
      <PlusIcon />
    </a>
  )
}
